





































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import editor from '@/components/common/summernote/Index.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import TagMaker from '@/components/common/input/TagMaker.vue';
import {ncpPopup} from '@/utils/ncp';
import { getLocalStorageMalls, uploadFile } from '@/utils/commonUtils';
import {PostBoardsBoardNoPostsRequest, Mall} from 'supporter';
import {Admin} from '@/types';
import {namespace} from 'vuex-class';
const adminModule = namespace('admin');
@Component({
  components: {
    editor,
    PageTitle,
    TagMaker
  }
})
export default class ArticleFormAdd extends Vue {
  @adminModule.Getter('admin') private admin!: Admin;
  private malls!: Mall[];
  @Watch('theForm.notice')
  onNoticeFn(val) {
    if (val) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }
  private data: any = {
    htmlContent: '',
    textContent: ''
  };
  private isDisabled: boolean = true;
  private isReply: boolean = false;
  private isArticle: string = '';
  private isReplyUpdate: boolean = false;
  private isArticleImageRemoved: boolean = false;
  private boards: any[] = [];
  private noticeShow = true;
  private parentTextShow = false;
  private isReplyMode = false;
  private isFixedOrder = false;
  private replyParentTextShow: boolean = false;
  private theForm: any = {
    title: '',
    opening: true,
    mallNo: 0,
    boardNo: '',
    categoryNo: '',
    notice: false,
    file: '',
    content: '',
    orderFixed: false,
    tags: [],
  };
  private detailData: any = {
    no: '',
    writerName: '',
    writeDateTime: '',
    readCount: 0,
    editorName: '',
    editDateTime: '',
    writerNo: 0,
    editorNo: 0,
    writerType: '',
    editerType: '',
    replyCount: 0,
    recommendCount: 0,
  };
  private tagNumberLimit = 20;
  private fileNumberLimit = 10;
  private editorOnChange({html, text}: {html: string; text: string}): void {
    Object.assign(this.data, {htmlContent: html, textContent: text});
  }

  private changeMall() {
    let obj = {
      params: {
        mallNo: this.theForm.mallNo
      }
    };
    this.$api.getBoards(obj).then((res: any) => {
      this.boards = res.data;
      if(this.boards.length) {
        this.boards = this.boards.reverse();
      }
      const $boardSelect = $('#board');
      $boardSelect.text('');
      $boardSelect.append(`<option value="">${window.$t('BOARD_ARTICLE_FORM_SELECT_BOARD')}</option>`);
      if (!this.isReplyMode) {
        if (this.boards.length >= 1) {
          $boardSelect.removeAttr('disabled');
          this.boards.forEach(board => {
            const selected = board.boardNo == this.theForm.boardNo ? 'selected' : '';
            $boardSelect.append(`<option value='${board.boardNo}' ${selected}>${board.boardName}</option>`);
          });
        } else {
          $boardSelect.attr('disabled', 'disabled');
        }
      } else {
        if (this.boards.length >= 1) {
          this.boards.forEach(board => {
            const selected = board.boardNo == this.theForm.boardNo ? 'selected' : '';
            $boardSelect.append(`<option value='${board.boardNo}' ${selected}>${board.boardName}</option>`);
          });
        }
        $boardSelect.attr('disabled', 'disabled');
      }
      this.setCategorySelect();
    });
  }
  private setCategorySelect() {
    const selectedBoardNo = this.theForm.boardNo;
    const [currentBoard] = this.boards.filter(board => board.boardNo == selectedBoardNo);
    if (currentBoard && currentBoard.thumbnailUsed) {
      // 대표이미지 추가 보이기
      $('#article_image_tr').removeClass('hide');
      const $articleImageUrl = $('#article_image_url');
      if ($articleImageUrl.val()) {
        this.setPreviewImage($('#article_image_tr .image_area'), $articleImageUrl.val());
      }
    } else {
      $('#article_image_tr').addClass('hide');
    }
    const categorySelect = $('select[name="boardCategory.boardCategoryNo"]');
    if (!this.isReply && !this.isReplyUpdateMode) {
      this.theForm.categoryNo = '';
      categorySelect.text('');
    }
   
    this.isReply = false;
    categorySelect.append(`<option value="">${window.$t('BOARD_ARTICLE_FORM_SELECT_CATEGORY')}</option>`);
    if (!this.isReplyMode) {
      if (currentBoard && currentBoard.categoryUsed) {
        const categories = currentBoard.categories.sort((a, b) => {
          if (a.categoryNo < b.categoryNo) return -1;
          else if (a.categoryNo > b.categoryNo) return 1;
          else return 0;
        });
        categories.forEach((category: any) => {
          const selected = category.categoryNo == this.theForm.categoryNo ? 'selected' : '';
          categorySelect.append(`<option value='${category.categoryNo}' ${selected}>${category.categoryName}</option>`);
        });
        categorySelect.removeAttr('disabled');
      } else {
        categorySelect.attr('disabled', 'disabled');
      }
    } else {
      if (this.result.category) {
        if (this.result.category.no !== 0) {
          this.theForm.categoryNo = this.result.category.no;
        }
      }
      // 답글 등록 모드
      if (currentBoard && currentBoard.categoryUsed) {
        const categories = currentBoard.categories;
        categories.forEach((category: any) => {
          const selected = category.categoryNo == this.theForm.categoryNo ? 'selected' : '';
          categorySelect.append(`<option value='${category.categoryNo}' ${selected}>${category.categoryName}</option>`);
        });
      }
      categorySelect.attr('disabled', 'disabled');
    }
    this.$nextTick(() => {
      if(this.isReplyUpdateMode){
        this.boardDis = true;
        this.categoryDis = true;
        $('#board').attr('disabled','disabled')
        $('#category').attr('disabled','disabled')
      }
    });
  }
  private checkform() {
    if (!this.isReply) {
      const $board = $('#board');
      if ($board.is(':disabled')) {
        window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_BOARD_DISABLED'));
        return false;
      }
      if (!$board.is(':disabled') && !$('#board option:selected').val()) {
        window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_BOARD_NO_SELECT'));
        return false;
      }
      if (!$('[name="boardCategory.boardCategoryNo"]').is(':disabled') && !$('[name="boardCategory.boardCategoryNo"] option:selected').val()) {
        window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_CATEGORY_DISABLED'));
        return false;
      }
    }
    if (!$('[name=articleTitle]').val()) {
      window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_ARTICLE_TITLE'));
      return false;
    }
    const $answerContent = $('#answerContent');
    if ($answerContent.summernote('isEmpty')) {
      window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_SUMMERNOTE_EMPTY'));
      return false;
    }
    if ($answerContent.summernote('code').length > 16777215) {
      window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_SUMMERNOTE_LONG'));
      return false;
    }
    return true;
  }
  private replyCheckForm() {
    if (!$('[name=articleTitle]').val()) {
      window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_ARTICLE_TITLE'));
      return false;
    }
    const $answerContent = $('#answerContent');
    if ($answerContent.summernote('isEmpty')) {
      window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_SUMMERNOTE_EMPTY'));
      return false;
    }
    if ($answerContent.summernote('code').length > 16777215) {
      window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_SUMMERNOTE_LONG'));
      return false;
    }
    return true;
  }
  private onClickSave() {
    if (!this.isReplyMode) {
      // 수정 화면 가리킴
      if(this.$route.query.mode === 'replyUpdate'){
        if (!this.replyCheckForm()) {
          return false;
        }
      }else{
        if (!this.checkform()) {
          return false;
        }
      }
      if (!window.confirm(this.$t('BOARD_ARTICLE_FORM_CONFIRM_SAVE') as any)) {
        return false;
      }
      const attachFiles: any[] = [];
      $('.file').each((index, file) => {
        const originalName = $(file)
          .find('[name=originalFileName]')
          .val();
        const uploadedName = $(file)
          .find('[name=uploadedFileName]')
          .val();
        attachFiles.push({
          originalFileName: originalName,
          uploadedFileName: uploadedName
        });
      });

      let articleImageUrl;
      if (!this.isArticleImageRemoved) {
        articleImageUrl = $('input[name=articleImage]').data('url') || $('#article_image_url').val();
      } else {
        articleImageUrl = '';
      }
      if (!this.isReplyUpdate) {
        let obj = {
          pathParams: {
            boardNo: this.theForm.boardNo
          },
          data: {
            parentPostNo: null,
            imageUrl: articleImageUrl,
            categoryNo: this.theForm.categoryNo !== '' ? Number(this.theForm.categoryNo) : null,
            files: attachFiles,
            opened: this.theForm.opening,
            title: this.theForm.title,
            mallNo: Number(this.theForm.mallNo),
            secreted: false,
            content: this.data.htmlContent,
            notice: this.theForm.notice,
            tags: this.theForm.tags,
          }
        };
        this.$api.postBoardsBoardNoPosts(obj).then((res: any) => {
          window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_SUCCESS'));
          $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback as string}(${JSON.stringify(res)},${this.isReplyUpdate});`);
          self.close();
        });
      } else {
        let obj = {
          pathParams: {
            boardNo: this.theForm.boardNo,
            postNo: this.detailData.no
          },
          data: {
            orderFixed: this.theForm.orderFixed,
            imageUrl: articleImageUrl,
            categoryNo: this.theForm.categoryNo !== '' ? Number(this.theForm.categoryNo) : null,
            files: attachFiles,
            opened: this.theForm.opening,
            title: this.theForm.title,
            mallNo: Number(this.theForm.mallNo),
            secreted: false,
            content: this.data.htmlContent,
            notice: this.theForm.notice,
            tags: this.theForm.tags,
          }
        };
        this.$api.putBoardsBoardNoPostsPostNo(obj).then((res: any) => {
          window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_SUCCESS'));
          $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback as string}(${JSON.stringify(res)},${this.isReplyUpdate});`);
          self.close();
        });
      }
      return true;
    } else {
      // 답글 등록
      if (!this.replyCheckForm()) {
        return false;
      }
      if (!window.confirm(this.$t('BOARD_ARTICLE_FORM_CONFIRM_SAVE') as any)) {
        return false;
      }
      const attachFiles: any[] = [];
      $('.file').each((index, file) => {
        const originalName = $(file)
          .find('[name=originalFileName]')
          .val();
        const uploadedName = $(file)
          .find('[name=uploadedFileName]')
          .val();
        attachFiles.push({
          originalFileName: originalName,
          uploadedFileName: uploadedName
        });
      });

      let articleImageUrl;
      if (!this.isArticleImageRemoved) {
        articleImageUrl = $('input[name=articleImage]').data('url') || $('#article_image_url').val();
      } else {
        articleImageUrl = '';
      }
      let replyRequest: PostBoardsBoardNoPostsRequest = {
        pathParams: {
          boardNo: Number(this.$route.query.boardNo)
        },
        data: {
          parentPostNo: Number(this.$route.query.parentArticleNo),
          imageUrl: articleImageUrl,
          categoryNo: this.theForm.categoryNo,
          files: attachFiles,
          opened: this.theForm.opening,
          title: this.theForm.title,
          mallNo: this.theForm.mallNo,
          content: this.data.htmlContent,
          secreted: this.result.secreted,
          notice: this.theForm.notice
        }
      };
      this.$api.postBoardsBoardNoPosts(replyRequest).then((res: any) => {
        window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_SUCCESS'));
        $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback as string}(${JSON.stringify(res)},${false});`);
        self.close();
      });
    }
  }
  private onClickCancel() {
    if (!window.confirm(this.$t('BOARD_ARTICLE_FORM_CONFIRM_CANCEL') as any)) {
      return false;
    }
    self.close();
    return true;
  }
  private clickMemberPopup(memberNo) {
    ncpPopup(`/member/popup/crm/${memberNo}`, window.$t('BOARD_ARTICLE_LIST_MEMBER_INFO'), 1100, 980);
  }
  private onChangeNoticeYn(event: any) {
    (document.querySelector('#orderFixed') as any).disabled = !event.target.checked;
  }
  private onClickFindImageBtn(e: any) {
    var $imageArea = $(e.target).parents('.image_area');
    $imageArea.find('[type=file]').trigger('click');
  }
  private onChangeFile(event: any) {
    const {files} = event.target;
    const [file] = files;
    if (file.size / Math.pow(1024, 2) > 5) {
      $(event.target).val('');
    }
    // 파일 업로드
    const mallNo = $('select[name=mallNo] option:selected').val();
    uploadFile(files, mallNo as any).then((responses: any) => {
      if (responses.length > 0) {
        responses.forEach((uploadedFile: any) => {
          if (uploadedFile) {
            let url = uploadedFile.data.url;
            let fileName = url.split('/')[url.split('/').length - 1];
            const fileDom = (
              '<span class="file">{fileName} <button class="delete-file-btn">x</button>' +
              '<input name="originalFileName" type="hidden" value="{fileName}">' +
              '<input name="uploadedFileName" type="hidden" value="{uploadedFileName}">' +
              '</span>'
            )
              .replace(/{fileName}/g, fileName)
              .replace(/{uploadedFileName}/g, url);
            // '</span>').replace(/{fileName}/g, uploadedFile.originalFileName)
            //     .replace(/{uploadedFileName}/g, uploadedFile.uploadedFileName);
            $('[name=add_file_btn]')
              .parent()
              .append(fileDom);
          }
        });
        $(event.target).val('');
      } else {
        window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_ERROR'));
        $(event.target).val('');
      }
    }).finally((): any => {
      $(event.target).val('');
    });
  }
  private onClickDeleteFile(e: any) {
    if (!window.confirm(this.$t('BOARD_ARTICLE_FORM_CONFIRM_DELETE') as any)) {
      return false;
    }
    const target = $(e.target);
    target.parent('span.file').remove();
    return true;
  }
  private onClickAddFile() {
    if ($('.file').length >= this.fileNumberLimit) {
      window.alert(this.$t('BOARD_ARTICLE_FORM_ALERT_FILE_LENGTH'));
      return false;
    }
    $('[name=add_file]').trigger('click');
    return true;
  }
  private onChangeArticleImageFile(event: any) {
    const $imageArea = $(event.target).parents('.image_area');
    const {files} = event.target;
    const mallNo = $('select[name=mallNo] option:selected').val();
    uploadFile(files, mallNo as any).then((responses: any) => {
      const data = responses.map((res: any): {} => {
        return {url: res.data.url};
      });
      $(event.target).data('url', data[0].url);
      this.setPreviewImage($imageArea, data[0].url);
    }).finally((): any => {
      $(event.target).val('');
    });
    this.isArticleImageRemoved = false;
  }
  private setPreviewImage($imageArea: any, url: any) {
    $imageArea
      .find('.preview')
      .empty()
      .append(`<img src="${url}" style="width:100%;" />`)
      .show();
    $imageArea.find('.remove').show();
  }
  private onClickRemoveImageBtn(e: any) {
    // preview image 삭제
    const $imageArea = $(e.target).parents('.image_area');
    const $mainImage = $(e.target).siblings('input[type=file]');

    $mainImage.data('url', '').data('image_no', '');
    $mainImage.val('');
    $imageArea.find('.preview').html('');
    $imageArea.find('.preview').css('display', '');
    $imageArea.find('.remove').hide();
    this.isArticleImageRemoved = true;
  }

  private async setInitData() {
    let theData = JSON.parse(localStorage.getItem('articleDetail'));
    this.theForm.mallNo = theData.mallNo;
    $('select[name="mallNo"]').attr('disabled', 'disabled');
    await this.changeMall();
    this.theForm.boardNo = theData.boardNo + '';
    if(theData.categoryNo){
      this.theForm.categoryNo = String(theData.categoryNo)
    }else{
      this.theForm.categoryNo = '';
    }
    // this.theForm.categoryNo = theData.categoryNo ? String(theData.categoryNo) : '';
    this.theForm.title = theData.title;
    this.theForm.file = theData.files;
    this.theForm.notice = theData.noticed;
    this.theForm.opening = theData.opened;
    this.theForm.content = theData.content.replaceAll('\n', '<br>');
    this.theForm.tags = theData.tags;
    this.detailData.no = theData.no;
    this.detailData.writerName = theData.writerName;
    this.detailData.writeDateTime = theData.writeDateTime;
    this.detailData.readCount = theData.readCount;
    this.detailData.editorName = theData.editorName;
    this.detailData.editDateTime = theData.editDateTime;
    this.detailData.replyCount = theData.replyCount;
    this.detailData.recommendCount = theData.recommendCount;
    const $imageArea = $('input[name=articleImage]').parents('.image_area');
    // 判断初始是否为check状态
    if (this.theForm.notice) {
      // check状态 显示순서고정
      this.isFixedOrder = true;
      this.theForm.orderFixed = theData.orderFixed;
    }
    if (theData.thumbnailUrl) {
      $('#article_image_url').val(theData.thumbnailUrl);
      this.setPreviewImage($imageArea, theData.thumbnailUrl);
    }
    if (theData.files.length > 0) {
      theData.files.forEach((uploadedFile: any) => {
        if (uploadedFile) {
          let url = uploadedFile.uploadedName;
          let fileName = uploadedFile.originalName;
          const fileDom = (
            '<span class="file"><a href="javascript:window.downloadFile(\'{uploadedFileName}\',\'{fileName}\')">{fileName}</a><button class="delete-file-btn">x</button>' +
            '<input name="originalFileName" type="hidden" value="{fileName}">' +
            '<input name="uploadedFileName" type="hidden" value="{uploadedFileName}">' +
            '</span>'
          )
            .replace(/{fileName}/g, fileName)
            .replace(/{uploadedFileName}/g, url);
          $('[name=add_file_btn]')
            .parent()
            .append(fileDom);
        }
      });
    }
  }
  private downloadFile(uploadedFileName: any, originFilename: any) {
    // let url = '';
    // if (uploadedFileName.startsWith('//rlyfaazj0.toastcdn.net')) {
    //   let imgArr = uploadedFileName.split('_');
    //   url = imgArr[0];
    //   let xmlhttp = new XMLHttpRequest();
    //   xmlhttp.open('GET', url, true);
    //   xmlhttp.responseType = 'blob';
    //   xmlhttp.onload = function() {
    //     if (this.status == 200) {
    //       var blob = this.response;
    //       var a = document.createElement('a');
    //       a.href = window.URL.createObjectURL(blob);
    //       a.download = originFilename;
    //       document.body.appendChild(a);
    //       a.click();
    //       document.body.removeChild(a);
    //     }
    //   };
    //   xmlhttp.send();
    // } else {
    //   let url = `${process.env.VUE_APP_PREVIOUS_API_URL}/object-storage?fileName=${encodeURI(uploadedFileName)}&serviceNo=${this.admin.serviceNo}&container=attachment`;
    //   window.location.assign(url);
    // }
    let imgArr = uploadedFileName.split('_');
    let url = '';
    const cdnImageUrl = ['//rlyfaazj0.toastcdn.net', '//shopby-images.cdn-nhncommerce.com'];
    if (!cdnImageUrl.some(url => uploadedFileName.startsWith(url))) {
      let res = new Date(parseInt(imgArr[0]))
        .toLocaleString()
        .split(' ')[0]
        .split('/')
        .map(item => {
          if (parseInt(item) < 10) {
            return '0' + item;
          } else {
            return item;
          }
        })
        .join('');
      url = `//rlyfaazj0.toastcdn.net/SERVICE/${res}/${originFilename}`;
    } else {
      url = imgArr[0];
    }

    let xmlhttp = new XMLHttpRequest();
    xmlhttp.open('GET', url, true);
    xmlhttp.responseType = 'blob';
    xmlhttp.onload = function() {
      if (this.status == 200) {
        var blob = this.response;
        var a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = originFilename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    };
    xmlhttp.send();
  }

  private beforeMount() {
    this.malls = getLocalStorageMalls();
    if (this.$route.query.mallNo) {
      this.theForm.mallNo = this.$route.query.mallNo;
      this.changeMall();
    }
  }
  private isReplyUpdateMode: boolean = false; //답글 수정 모드
  private mounted() {
    if (this.$route.params.articleNo) {
      // 게시글 상세, 수정
      this.isReply = true;
      this.isReplyUpdate = true;
      this.isFixedOrder = false;
      this.setInitData();
      if(this.$route.query.mode === 'replyUpdate') {
        this.isReplyUpdateMode = true;
        this.isReply = true;
        this.parentTextShow = false;
        this.replyParentTextShow = true;
        this.noticeShow = false;
        
        this.setInitDataReplyUpdate();
      }
    } else if (this.$route.query.replyYn !== 'false') {
      // 답글 등록
      this.isReplyMode = true;//답글모드
      this.isReply = false;
      this.isReplyUpdate = false;
      this.isFixedOrder = false;
      this.theForm.notice = true;
      this.setInitDataReply();
    }
    (window as any).downloadFile = this.downloadFile;
    $('body').on('click', '.delete-file-btn', $.proxy(this.onClickDeleteFile, this));
  }
  private replyMallNoDis: boolean = false;
  private boardDis: boolean = false;
  private categoryDis: boolean = false;
  private result: any = {};
  private async setInitDataReply() {
    this.parentTextShow = true;
    this.replyMallNoDis = true;
    this.noticeShow = false;
    let theData = JSON.parse(localStorage.getItem('articleDetail'));
    this.theForm.notice = theData.noticed;
    this.theForm.mallNo = Number(this.$route.query.mallNo);
    this.theForm.boardNo = Number(this.$route.query.boardNo);
    $('select[name="mallNo"]').attr('disabled', 'disabled');
    await this.changeMall();

    let request = {
      pathParams: {
        boardNo: this.theForm.boardNo
      },
      params: {
        mallNo: this.theForm.mallNo,
        searchType: 'ALL',
        startDateTime: '2000-01-01 00:00:00',
        endDateTime: '2999-12-31 23:59:59',
        page: 1,
        pageSize: 10000,
      }
    };
    this.$api.getBoardsBoardNoPosts(request).then(ret => {
      ret.data.contents.forEach(e => {
        if (e.no === Number(this.$route.query.parentArticleNo)) {
          this.result = e;
        }
      });
      this.theForm.secreted = this.result.secreted;

      if (this.result.category) {
        if (this.result.category.no !== 0) {
          this.theForm.categoryNo = this.result.category.no;
        }
      }
    });
  }
   private async setInitDataReplyUpdate() {
    
    let theData = JSON.parse(localStorage.getItem('articleDetail'));
    this.theForm.mallNo = theData.mallNo
    this.theForm.boardNo = Number(this.$route.query.boardNo);
    this.detailData.no = theData.no;

    let repliesData = JSON.parse(localStorage.getItem('articleRepliesInfo'));
    if(repliesData[0].writer){
      this.detailData.writerNo = repliesData[0].writer.no;
      this.detailData.writerName = repliesData[0].writer.name;
      this.detailData.writerType = repliesData[0].writer.type;
    }
    if(repliesData[0].editor){
      this.detailData.editorNo = repliesData[0].editor.no;
      this.detailData.editorName = repliesData[0].editor.name;
      this.detailData.editorType = repliesData[0].editor.type;
    }

    await this.changeMall();

    let request = {
      pathParams: {
        boardNo: this.theForm.boardNo
      },
      params: {
        mallNo: this.theForm.mallNo,
        searchType: 'ALL',
        startDateTime: '2000-01-01 00:00:00',
        endDateTime: '2999-12-31 23:59:59',
        page: 1,
        pageSize: 10000,
      }
    };
    this.$api.getBoardsBoardNoPosts(request).then(ret => {
      ret.data.contents.forEach(e => {
        if (e.no === Number(this.$route.query.parentArticleNo)) {
          this.result = e;
        }
      });
      this.theForm.secreted = this.result.secreted;

      if (this.result.category) {
        if (this.result.category.no !== 0) {
          this.theForm.categoryNo = this.result.category.no;
        }
      }
      this.$nextTick(() => {
        $('#board').attr('disabled','disabled')
        $('#category').attr('disabled','disabled')
        this.boardDis = true;
        this.categoryDis = true;
        this.isReply = true;
      })
    });
  }

  private countChange() {
    if (this.theForm.title) {
      if (this.theForm.title.length === 0) {
        return '';
      } else if (this.theForm.title.length === 50) {
        return ' max';
      } else {
        return ' counting';
      }
    }
  }

  private handleTagMakerOverflow() {
    alert(this.$t('TAG_NUMBER_LIMIT_ALERT_MSG', { number: this.tagNumberLimit }));
  }

  private beforeDestroy() {
    $('body').off('click', '.delete-file-btn');
  }
}
